<template>
  <div class="mw-panel">
    <mw-dialog ref="dialog" size="full" title="动作脚本" :before-close="handleClose">
      <div class="mw-toolbar">
        <el-button @click="save" type="primary"><i class="fa fa-plus-square" type="primary"></i>保存</el-button>
        &nbsp;&nbsp;<el-button @click="saveClose" type="primary"><i class="fa fa-plus-square" type="primary"></i>保存关闭</el-button>
        <!--<el-button @click="close" type="primary"><i class="fa fa fa-mail-reply" type="primary"></i>关闭</el-button>
      -->
      </div>
      <div class="mw-toolbar__body">
        <el-tabs type="card">
          <el-tab-pane>
            <span slot="label">基础配置</span>
            <div class="mw-panel">
              <split-pane :defaultPercent="50" split="vertical">
                <template slot="paneL">
                  <div class="mw-panel-y" style="margin-right:5px;">
                  <el-form label-width="100px" style="width:90%;" class="mw-form" :model="form" ref="form">
                <el-col :span="24">
                  <el-form-item prop="id" v-show="false">
                    <el-input v-model="form.id"></el-input>
                  </el-form-item>
                  <el-form-item label="名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                  </el-form-item>
                  <el-form-item label="标识" prop="action">
                    <el-input v-model="form.action"></el-input>
                  </el-form-item>
                  <el-form-item label="分类" prop="type">
                    <el-input v-model="form.type"></el-input>
                 <!--   <el-select v-model="form.type" placeholder="请选择类型">
                      <el-option :label="t.label" :value="t.id" :key="t.id" v-for="t in type"></el-option>
                    </el-select>-->
                  </el-form-item>
                  <el-form-item label="生效公式" prop="effectiveFormula">
                    <el-input v-model="form.effectiveFormula"></el-input>
                  </el-form-item>
                  <el-form-item label="是否默认" prop="isDefault">
                    <el-radio-group v-model="form.isDefault">
                      <el-radio label="1">是</el-radio>
                      <el-radio label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" :rows="3" v-model="form.remark"></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
                  </div>
                </template>
                <template slot="paneR">
                  <mw-dialog size="mini_mini" ref="paramsDialog" :title="title" :footerButton="paramsFooterButton"
                             :close-on-click-modal="false">
                    <el-form :model="paramsForm" label-width="70px" ref="paramsForm" style="margin-top:20px;">
                      <el-col :span="24">
                        <el-form-item label="名称">
                          <el-input v-model="paramsForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="描述">
                          <el-input v-model="paramsForm.description"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-form>
                  </mw-dialog>
                  <toolbar-table ref="paramsToolbarTable" :toolbarTitle="toolbarTitle" :toolbarTitleWidth="200"
                                 :pagination="false"
                                 :showHeader="true" :layout="paramsLayout"></toolbar-table>
                </template>
              </split-pane>
            </div>
          </el-tab-pane>
          <el-tab-pane class="script-box">
            <span slot="label">javascript脚本</span>
            <mw-code-edit :value='javascript' ref="javascript"></mw-code-edit>
          </el-tab-pane>
          <el-tab-pane class="script-box">
            <span slot="label">groovy脚本</span>
            <mw-code-edit :value='groovy' lang="Groovy" ref="groovy"></mw-code-edit>
          </el-tab-pane>
        </el-tabs>
      </div>
    </mw-dialog>
    <split-pane :defaultPercent="25" split="vertical">
      <template slot="paneL">
        <div class="mw-split-left">
          <div class="mw-toolbar">
            <el-button @click="expand" size="mini"><i class="fa fa-angle-double-down"></i>展开</el-button>
            <el-button @click="closed" size="mini"><i class="fa fa-angle-double-up"></i>折叠</el-button>
          </div>
          <div class="mw-toolbar__body">
            <mw-tree :url="actionTreeUrl" :async="false" :multiple="false" :selectFirst="true" :expandedFirst="true"
                     @changed="loadTableTree" ref="actionTree">
            </mw-tree>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">
          <toolbar-table :layout="layout" :autoLoad="false" ref="toolbarTable">
            <span slot="more">
              <el-dropdown trigger="hover" @command="handleCommand">
                <el-button class="el-dropdown-link">
                  更多 <i class="fa fa-angle-double-right"></i>
                </el-button>
                <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                  <el-dropdown-item command="import">导出</el-dropdown-item>
                  <el-dropdown-item command="export">导入</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </toolbar-table>
        </div>
      </template>
    </split-pane>
  </div>
</template>
<script>

  export default {
    data() {
      let me = this;
      return {
        actionTreeUrl: this.mwUrl("/api/app/listActionComponentTree"),
        layout: [],
        paramsLayout:[],
        title: '参数',
        toolbarTitle: '参数列表',
        javascript: '',
        groovy: '',
        params: [],
        paramsForm: {
          id:'',
          name: '',
          description: ''
        },
        paramsFooterButton: [
          {label: '取消', func: me.paramsCancel, type: 'default'},
          {label: '连续添加', func: me.paramsContinueSure},
          {label: '确定', func: me.paramsSure}
        ],
        form: {
          id: '',
          name: '',
          action: '',
          type: '',
          isDefault: '0',
          remark: '',
          effectiveFormula: 'false'
        },
        versionNumber:1,
        defaultParams: {type: ''},
      };
    },
    mounted() {
      let me = this;
      me.paramsLayout = [
        [{
          span: 0,
          key: 'service',
          type: 'menu',
          defaultActive: true,
          dataList: me.params,
          columns: [
            {type: 'selection'},
            {prop: 'name', label: '参数名称', width: '180'},
            {prop: 'description',tooltip:true, label: '说明'}
          ]
        },{
          span: 20, offset: 4, type: 'button', items: [
            {label: '上移', icon: 'fa fa-arrow-circle-up', func: me.up},
            {label: '下移', icon: 'fa fa-arrow-circle-down', func: me.down},
            {label: '添加', icon: 'fa fa-plus-square', func: me.add},
            {label: '编辑', icon: 'fa fa-edit', func: me.edit},
            {label: '删除', icon: 'fa fa-trash-o', func: me.delete}]
        }]
      ];

      me.layout = [
        [{
          span: 0,
          type: 'menu',
          api: 'app.listActionComponent',
          defaultParams: me.defaultParams,
          columns: [
            {type: 'selection'},
            {prop: 'name', label: '名称', formatter: me._titleFormatter},
            {prop: 'action', label: '标识'},
            {prop: 'isDefault', label: '是否默认', formatter: me.defaultFlagFormatter, width: '120'},
            {prop: 'userName', label: '修改人', width: '60'},
            {prop: 'lastModifiedTime', label: '修改时间', width: '170'},
            {prop: 'remark', label: '备注'},
          ]
        }, {
          span: 10, type: 'button', items: [
            {label: '新增', icon: "fa fa-plus-square", func: me.addAction},
            {label: '编辑', icon: "fa fa-pencil fa-fw", func: me.editAction},
            {label: '删除', icon: "fa fa-trash-o fa-fw", func: me.deleteAction}],suffixSlot:"more"}
        ]]
    },
    watch: {

    },
    methods: {
      handleCommand(command){
        if(command === 'import'){
          let selection = this.mwRef('toolbarTable').getMultipleSelection();
          PF.func.view.exportComponentByIds(selection);
        }
        if(command === 'export'){
          PF.show('importComp',{},(v)=>{
            this.mwRef('toolbarTable').refreshTable()
            this.mwRef('actionTree').refresh();
          });
        }
      },
      addAction(data) {
        let me = this;
        me.form.id = '';
        me.form.name = '';
        me.form.action = '';
        let sel=me.mwRef("actionTree").getSelected();
        if(sel)
          me.form.type=sel.code
        else
          me.form.type =''

        me.form.isDefault = '0'
        me.form.remark = '';
        me.form.effectiveFormula = 'false';
        me.javascript = '';
        me.groovy = '';

        me.mwLodash.remove(me.params, function (o) {
          return true;
        })
        this.mwRef('dialog').show();
      },
      _valid(){
        let me=this;
        if (me.form.name == '') {
          me.mwMsg("warning", "请输入名称！");
          return false;
        }
        if (me.form.action == '') {
          me.mwMsg("warning", "请输入标识！");
          return  false;
        }

        if (!(me.form.action).match(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/)) {
          me.mwMsg('warning', '输入正确的标识，标识可以是字母、数字、$、_(下划线)，但不可用数字开头');
          return false
        }

        if (me.form.type == '') {
          me.mwMsg("warning", "请输入分类！");
          return  false;
        }
        return true;
      },
      editAction(data) {
        let me = this;
        if (data.length == 0 || data.length > 1) {
          me.mwMsg("warning", "请选择一条记录！");
        } else {
          me.mwApi.app.getScriptComponent(data[0].id).then((res) => {
            let d = res.result;
            me.form.id = d.id;
            me.form.name = d.name;
            me.form.action = d.action;
            me.form.type = d.type;
            me.form.isDefault = d.isDefault;
            me.form.remark = d.remark;
            me.form.effectiveFormula = d.effectiveFormula;
            me.javascript = d.javascript;
            me.groovy=d.groovy;
            me.versionNumber=d['#versionNumber'];
            me.mwLodash.remove(me.params, function (o) {
              return true;
            })
            let params=d.params;
            if(params){
              params.forEach(v=>{
                me.params.push(v);
              })
            }
            /*me.mwRef("actionTree").refresh();*/
            me.mwRef('dialog').show();
          });
        }
      },
      expand() {
        this.mwRef("actionTree").openAll();
      },
      closed() {
        this.mwRef("actionTree").closeAll();
      },
      save(e,flag) {
        let me = this, params = {};
        if (me.form.id != '') {
          params.id = me.form.id;
        }

        if(!me._valid()){
          return;
        }
        params.name = me.form.name;
        params.action = me.form.action;
        params.type = me.form.type;
        params.isDefault = me.form.isDefault;
        params.remark = me.form.remark;
        params.effectiveFormula = me.form.effectiveFormula;
        params.javascript = me.mwRef('javascript').getValue();
        params.groovy = me.mwRef('groovy').getValue();

        params['#versionNumber']=me.versionNumber;
        params['#sync']=true;

        me.javascript=params.javascript;
        me.groovy=params.groovy;
        if(_.trim(params.groovy).length>0)
          params.extends={ref:"action-groovy-service"};

        params.params=me.params;
        me.mwApi.app.createActionComponent(params).then((res) => {
          me.mwMsg("保存成功！");
          if(flag){
            this.mwRef('dialog').hide();
            me.mwRef("actionTree").refresh();
            me.mwRef('toolbarTable').refreshTable();
          }else{
            if (res && res.result) {
              var d = res.result;
              me.versionNumber=d['#versionNumber'];
              me.form.id = d.id;
            }
          }
        });
      },

      saveClose(e) {
        this.save(e,true);
      },
      close() {
        this.mwRef('dialog').hide();
      },
      handleClose() {
        let me = this;
        this.mwRef('dialog').hide();
        me.mwRef("actionTree").refresh();
        me.mwRef('toolbarTable').refreshTable();
      },
      deleteAction: function (data) {
        let me = this;
        if (data.length == 0) {
          me.mwMsg("info", "请至少选择一条记录！");
        } else {
          me.mwConfirm('您确定要删除所选记录').then(() => {
            let p = [];
            data.forEach(function (d) {
              p.push(d.id);
            })
            me.mwApi.app.removeComponent(p).then(res => {
              if (res.success) {
                me.mwMsg("删除成功");
                me.mwRef("actionTree").refresh();
                me.mwRef('toolbarTable').refreshTable();
              } else {
                me.mwMsg('warning', '删除失败');
              }
            })
          }).catch(() => {

          });
        }
      },
      up(a) {
        let me = this;
        a.forEach(v => {
          let idx = me.mwLodash.findIndex(me.params, function (o) {
            return o.id == v.id
          });
          if (idx > 0) {
            let remove = me.mwLodash.remove(me.params, function (o) {
              return o.id == v.id;
            });
            me.params.splice(idx - 1, 0, remove[0]);
          }
        })
      },
      down(a) {
        let me = this;
        a.forEach(v => {
          let idx = me.mwLodash.findIndex(me.params, function (o) {
            return o.id == v.id
          });
          if (idx < me.params.length) {
            let remove = me.mwLodash.remove(me.params, function (o) {
              return o.id == v.id;
            });
            me.params.splice(idx + 1, 0, remove[0]);
          }
        })
      },
      reset() {
        this.paramsForm.id=$uuid();
        this.paramsForm.name = '';
        this.paramsForm.description = '';
      },
      add() {
        let me = this;
        me.reset();
        me.mwRef('paramsDialog').show();
      },
      edit(a, b) {
        if (a.length == 0) {
          b.mwMsg('warning', '请选择需要编辑的记录');
          return;
        }
        if (a.length > 1) {
          b.mwMsg('warning', '请选择一条需要编辑的记录');
          return;
        }
        this.mwLodash.assign(this.paramsForm, a[0]);
        this.mwRef('paramsDialog').show();
      },

      delete(a, b) {
        let me = this;
        if (a.length == 0) {
          b.mwMsg('warning', '请选择需要删除的记录');
          return;
        }
        a.forEach(v => {
          for (let i = 0; i < me.params.length; i++) {
            let v1 = me.params[i];
            if (v.id == v1.id) {
              me.params.splice(i, 1);
              break;
            }
          }
        })
      },

      paramsContinueSure() {
        if (this.paramsSure(true)) {
          this.reset();
        }
      },
      paramsSure(noCancel) {
        let form = {};
        let me = this;
        let flag = false;

        this.params.forEach(v => {
          if (v.id == this.paramsForm.id) {
            form = v;
            flag = true;
          }
        })
        me.paramsForm.name = me.paramsForm.name.trim()
        if (me.paramsForm.name == '') {
          me.mwMsg('warning', '参数名称不能为空');
          return false
        }
        if (!(me.paramsForm.name).match(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/)) {
          me.mwMsg('warning', '输入正确的参数名称，参数名称可以是字母、数字、$、_(下划线)，但不可用数字开头');
          return false
        }

        if (me.paramsForm.name) {
          if (!flag) {
            let idx = me.mwLodash.findIndex(me.params, function (o) {
              return o.name.toLowerCase() == me.paramsForm.name.toLowerCase()
            });
            if (idx > -1) {
              me.mwMsg('warning', '参数名称不能重复');
              return false
            }
          } else {
            let idx = me.mwLodash.findIndex(me.params, function (o) {
                return (o.name.toLowerCase() == me.paramsForm.name.toLowerCase()) && (o.id != form.id)
              }
            );
            if (idx > -1) {
              me.mwMsg('warning', '参数名称不能重复');
              return false
            }
          }
        }
        me.mwLodash.assign(form, me.paramsForm);

        if (!flag)
          me.params.push(form)
        if (!noCancel)
          me.paramsCancel();
        return true;
      },

      paramsCancel() {
        this.mwRef('paramsDialog').hide();
      },

      defaultFlagFormatter(data) {
        var me = this;
        return data.isDefault == '1' ? '是' : '否';
      },
      loadTableTree(data) {
        this.mwRef("toolbarTable").refreshTableDefaultParams({
          type: data.code
        });
      },
      _titleFormatter(a, b, c) {
        let me = this;
        return (<span class={{'link':true}} title={c} onClick={(event)=>me.editAction([a])}>{c?c:'无标题'}</span>)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/script.vue